var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmtpyPage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "349px",
    height: "320px",
    viewBox: "0 0 349 320",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CAAC9DAB-CD9A-4C67-A7BF-87165AB80A4D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "05.-Partner-Dashboard\\uD83D\\uDCBB",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9002_Project_Own_Empty",
    transform: "translate(-546.000000, -326.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Asset-2",
    transform: "translate(546.000000, 326.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-2",
    transform: "translate(0.000000, 18.000000)",
    fill: "#F2F5EC"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340.854223,56.4238852 L339.219202,52.8722195 C325.420504,22.9283822 296.430042,2.39462822 263.495,0.49064248 C259.265276,0.248856065 255.023541,0.314937911 250.803424,0.688364076 C220.317248,3.39055923 191.781366,22.4597087 177.674727,49.5695365 C169.360315,65.5117556 165.276429,84.529644 151.712353,96.3490016 C134.064391,111.727348 107.559454,109.09106 84.3978782,105.590655 C61.2363025,102.090251 34.7020378,99.5125472 17.120063,114.964124 C6.10016807,124.645159 1.15844538,139.701292 0.190630252,154.318044 C-2.36821429,193.027539 20.6613866,230.675196 53.1638445,251.91196 C85.6663025,273.148724 126.160567,279.58566 164.895168,276.612513 C219.151471,272.431068 273.019181,249.568593 308.689034,208.508408 C344.358887,167.448223 359.316029,107.567871 340.854223,56.4238852 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2",
    transform: "translate(10.000000, 318.000000)",
    fill: "#263238"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314.983185,0.918907563 C314.983185,1.04653361 244.596372,1.14012605 157.79915,1.14012605 C71.0019286,1.14012605 0.600470106,1.04653361 0.600470106,0.918907563 C0.600470106,0.791281513 70.9726374,0.697689076 157.79915,0.697689076 C244.625663,0.697689076 314.983185,0.799789916 314.983185,0.918907563 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-2",
    transform: "translate(282.000000, 176.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2744392,124.655955 C21.3092022,124.549632 21.3530049,124.446537 21.4053588,124.347819 C21.5071852,124.127721 21.6453782,123.834258 21.8126643,123.460092 C22.3189738,122.314269 22.7253904,121.126144 23.0273075,119.909183 C23.8273719,116.754451 24.1110311,111.934313 22.9254812,106.211775 C22.2849319,103.090214 21.4418379,100.014457 20.4016417,97.0043577 C19.3397381,93.7395763 18.0960016,90.2767071 17.0850112,86.527711 C15.9428971,82.6178267 15.3912089,78.5567029 15.4485159,74.4810346 C15.6012554,70.2184773 16.8522652,65.9705933 18.2269213,61.7300458 C19.6015773,57.4894983 21.0198733,53.3589996 21.4417254,49.1771449 C21.916253,45.1667636 21.1165848,41.10795 19.1579053,37.5853369 C17.3395771,34.2031701 15.0484837,31.3052181 13.3392552,28.3118905 C11.7390763,25.5305008 10.5599023,22.5235367 9.84079188,19.3906003 C8.81000669,14.8545652 8.7331979,10.1509613 9.61531919,5.58314296 C9.93484462,3.9112938 10.422244,2.27659235 11.0699817,0.704312384 C11.0486099,0.813889878 11.0194411,0.921772288 10.982702,1.02712223 L10.6917694,1.95886882 C10.3351385,3.16583577 10.0389822,4.39015034 9.80442532,5.62716248 C8.9914066,10.1742736 9.11270916,14.8413512 10.1608176,19.3392442 C10.8892428,22.4344197 12.0733961,25.4020095 13.6738276,28.143149 C15.383056,31.0777839 17.6814228,34.0124189 19.5433908,37.4092588 C21.5430966,41.0056614 22.3653147,45.1473815 21.8926708,49.2431742 C21.4635453,53.4837216 20.0379761,57.6582398 18.66332,61.8914507 C17.2886639,66.1246616 16.0522008,70.3285261 15.8994612,74.5177175 C15.8335161,78.5527824 16.3729937,82.5746998 17.49959,86.4470085 C18.4960338,90.1739949 19.7179503,93.6368641 20.7725806,96.9163186 C21.7995452,99.9438398 22.6256784,103.036928 23.2455069,106.175092 C24.2583161,110.718409 24.2583161,115.431895 23.2455069,119.975213 C22.9214285,121.194577 22.4855757,122.380881 21.943584,123.518784 L21.4926386,124.391838 C21.4279353,124.486323 21.3549056,124.574721 21.2744392,124.655955 L21.2744392,124.655955 Z",
    id: "Path",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6667152,31.2685352 C15.6667152,31.2685352 12.1900718,20.03622 18.430574,13.4626377 C18.5028803,13.3896115 18.6010029,13.3485781 18.7033232,13.3485781 C18.8056436,13.3485781 18.9037661,13.3896115 18.9760724,13.4626377 C19.0352436,13.5200999 19.0758093,13.5942648 19.0924454,13.6753988 C19.4270178,15.5095456 19.8415966,21.1587179 15.6667152,31.2685352 Z",
    id: "Path",
    fill: "#8CBF46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7541559,17.2042973 C17.7458039,17.9000804 17.6678264,18.593235 17.5214099,19.2732149 C17.2886639,20.7405324 17.0195514,22.3765914 16.7286189,24.2254114 C16.4376864,26.0742314 16.1685738,27.7543099 15.9431011,29.1776078 C15.880367,29.8715898 15.7586986,30.5588601 15.5794355,31.2318523 C15.5138964,30.5379625 15.5285413,29.83874 15.6230754,29.1482615 C15.7394484,27.8643587 15.964921,26.1035777 16.2776735,24.1667187 C16.5904259,22.2298596 16.9322716,20.498425 17.2013842,19.2291954 C17.3084706,18.5351715 17.4939342,17.8557867 17.7541559,17.2042973 L17.7541559,17.2042973 Z",
    id: "Path",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7543169,57.760952 C19.7543169,57.760952 21.8853975,46.1911538 30.4533597,43.3298848 C30.5507389,43.2949129 30.6579625,43.3008552 30.7509574,43.3463777 C30.8439522,43.3919002 30.9149263,43.4731884 30.9479449,43.5719922 C30.9696279,43.6512127 30.9696279,43.734879 30.9479449,43.8140995 C30.3806265,45.5968903 28.1331729,50.7838575 19.7543169,57.760952 Z",
    id: "Path",
    fill: "#8CBF46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1186263,46.3012026 C27.7857051,46.9117699 27.3960454,47.4890615 26.9548963,48.0253007 L23.9510182,52.0237408 L20.9689601,56.036854 C20.5924097,56.6183264 20.1665349,57.1657337 19.6961304,57.672913 C19.9649181,57.0288725 20.3066068,56.4183296 20.7143941,55.8534393 C21.4417254,54.774961 22.4308959,53.3223167 23.6237192,51.7596236 C24.8165424,50.1969305 25.900266,48.8249887 26.7221503,47.8272128 C27.1314557,47.2690094 27.5996974,46.7573347 28.1186263,46.3012026 Z",
    id: "Path",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4559501,86.7624818 C17.4559501,86.7624818 16.1613005,75.0679616 23.5364394,69.8223016 C23.6147637,69.7580557 23.7156639,69.7287857 23.8158575,69.7412458 C23.9160511,69.7537059 24.0068821,69.8068196 24.0673912,69.8883309 C24.1248939,69.9579931 24.1535506,70.0473391 24.1473977,70.1377749 C24.1110311,72.0232778 23.4491597,77.6431037 17.4559501,86.7624818 Z",
    id: "Path",
    fill: "#8CBF46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1690567,73.3658733 C22.0327012,74.0486545 21.8254826,74.7150636 21.5508251,75.3540885 L19.8343233,80.0641775 C19.1942718,81.8249585 18.6196801,83.4169979 18.1323682,84.7742666 C17.9453128,85.4420612 17.7019825,86.0924963 17.4050369,86.7184622 C17.4712048,86.0224182 17.6226754,85.3373351 17.8559823,84.678891 C18.2123746,83.4463443 18.7651464,81.744256 19.4415644,79.9101092 C20.1179825,78.0759624 20.779854,76.4252302 21.2817125,75.2440397 C21.5150699,74.5898741 21.8123125,73.9607258 22.1690567,73.3658733 L22.1690567,73.3658733 Z",
    id: "Path",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8928317,115.91808 C23.8928317,115.91808 23.0200342,104.17954 30.5697327,99.2053339 C30.6538081,99.1444256 30.7589581,99.120938 30.8606661,99.1403474 C30.9623742,99.1597569 31.051751,99.220367 31.1079578,99.3080461 C31.1556833,99.3764823 31.1787804,99.4593197 31.1734176,99.5428169 C31.0861378,101.457666 30.227887,107.055482 23.8928317,115.91808 Z",
    id: "Path",
    fill: "#8CBF46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0932502,102.712223 C28.9201568,103.391641 28.6763589,104.050704 28.3659189,104.678428 C27.8276938,106.013687 27.1876423,107.613063 26.482131,109.322488 C25.7766197,111.031913 25.1583881,112.623952 24.620163,113.966548 C24.4050734,114.628933 24.1299496,115.269924 23.7982787,115.881397 C23.8947507,115.187524 24.0729957,114.507748 24.3292305,113.856499 C24.7292627,112.638625 25.3402209,110.965883 26.0820988,109.153746 C26.8239767,107.341609 27.5367613,105.712887 28.0822598,104.553706 C28.3561673,103.906732 28.694925,103.289697 29.0932502,102.712223 L29.0932502,102.712223 Z",
    id: "Path",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6626762,21.4008252 C10.6626762,21.4008252 0.349119002,15.9424043 0.123646313,6.85237257 C0.123646313,6.63357076 0.299490453,6.45619685 0.516405191,6.45619685 C0.591366527,6.45015596 0.66604268,6.4709355 0.727331255,6.51488955 C2.2620002,7.5860313 6.5459813,11.2836713 10.6626762,21.4008252 Z",
    id: "Path",
    fill: "#8CBF46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.26927352,9.97775877 C2.75416539,10.4759972 3.18567216,11.0243765 3.55664984,11.6138177 C4.40035409,12.7803351 5.38225129,14.1596135 6.46597486,15.6782871 L9.37529988,19.7280833 C9.81696498,20.2619589 10.2112418,20.8339694 10.5535765,21.4375082 C10.0207998,20.9919306 9.5444495,20.4818673 9.13528056,19.9188346 C8.31339625,18.9357319 7.23694599,17.5271071 6.10230923,15.9350677 C4.96767247,14.3430282 3.97122865,12.8683742 3.28753727,11.7898958 C2.88663574,11.223167 2.54537166,10.6158418 2.26927352,9.97775877 Z",
    id: "Path",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7690245,45.4868414 C21.7690245,45.4868414 11.1208949,40.6813767 10.3717437,31.6060182 C10.354928,31.3936996 10.5105839,31.2072501 10.7208627,31.1878327 C10.8019325,31.1786703 10.8837358,31.1967204 10.9536087,31.2391888 C12.5464642,32.2809842 17.0195514,35.663151 21.7690245,45.4868414 Z",
    id: "Path",
    fill: "#8CBF46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7137503,34.6286922 C13.2284738,35.0928342 13.6918214,35.6118704 14.0956797,36.1767121 L17.2522974,40.0577668 L20.4161883,43.9241483 C20.8889177,44.431198 21.3172194,44.9785967 21.6962913,45.5602073 C21.1371164,45.1321551 20.6293967,44.6397159 20.1834423,44.0928899 C19.3106448,43.1538067 18.1469148,41.8185478 16.917725,40.2998742 C15.6885352,38.7812006 14.6120849,37.3652393 13.8556604,36.3307805 C13.4129521,35.8084056 13.0299068,35.2374528 12.7137503,34.6286922 L12.7137503,34.6286922 Z",
    id: "Path",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6230754,72.4341267 C15.6230754,72.4341267 8.34976281,63.2633925 11.7463998,54.8263171 C11.8269713,54.6280072 12.0514301,54.5328488 12.2482583,54.6135561 C12.3224661,54.6459289 12.3856704,54.6994824 12.4300911,54.7676244 C13.4410816,56.3596639 15.8630947,61.4659286 15.6230754,72.4341267 Z",
    id: "Path",
    fill: "#8CBF46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4810043,58.5533035 C12.7289103,59.2053017 12.9092788,59.8814214 13.0192295,60.570865 C13.3247086,61.9794898 13.6811009,63.6375585 14.0738598,65.4717053 C14.4666187,67.3058522 14.801191,68.9565843 15.1430367,70.3652091 C15.3383594,71.0336861 15.4722683,71.718879 15.5430689,72.4121169 C15.2249046,71.7878066 14.9807778,71.1278548 14.8157377,70.4459115 C14.4593454,69.2060283 14.0229466,67.5112766 13.6156411,65.5597444 C13.2083356,63.6082121 12.8883098,61.8914507 12.6846571,60.6295577 C12.540648,59.9472329 12.4723436,59.2508648 12.4810043,58.5533035 L12.4810043,58.5533035 Z",
    id: "Path",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8963879,104.062155 C22.8963879,104.062155 12.3282648,99.0806119 11.7318531,89.9979168 C11.7148624,89.7841396 11.8696003,89.595538 12.0809721,89.5723947 C12.1650724,89.5664306 12.2489352,89.5869379 12.3209915,89.6310874 C13.8847537,90.6361999 18.2996544,94.135752 22.8963879,104.062155 Z",
    id: "Path",
    fill: "#8CBF46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0011267,93.0205908 C14.4999967,93.5025343 14.9529279,94.0306384 15.3539628,94.597957 L18.4451206,98.5230312 L21.5435518,102.448105 C22.0094512,102.961459 22.4281738,103.516427 22.7945615,104.106174 C22.2532446,103.677509 21.7648674,103.184883 21.339899,102.638857 C20.4743748,101.6851 19.3397381,100.327832 18.1323682,98.7871484 C16.9249983,97.2464651 15.8776413,95.8525135 15.1357634,94.7666985 C14.6929916,94.2300513 14.312321,93.6442323 14.0011267,93.0205908 L14.0011267,93.0205908 Z",
    id: "Path",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9235345,57.8123082 L43.9235345,58.8027474 C43.9235345,59.5364062 43.8508014,60.4681528 43.7998882,61.6566799 C43.6689686,64.1657928 43.4725891,67.6653449 43.2471164,71.8471997 L43.2471164,71.8471997 C42.5197852,76.1024204 40.3377914,80.819846 37.4284664,85.4052131 C35.3119324,88.7800433 33.0644789,91.8467368 31.1734176,94.7006692 C29.4490217,97.2063216 27.8985295,99.8292989 26.5330442,102.550818 C25.6300827,104.390466 24.8995739,106.311224 24.3510504,108.288029 C24.1692176,108.985005 24.0237514,109.535249 23.9437449,109.909415 C23.9082156,110.104009 23.8571357,110.295385 23.7910054,110.481669 C23.7932631,110.283888 23.8176622,110.086997 23.8637385,109.894742 C23.9146517,109.513239 24.0237514,108.955658 24.1910375,108.244009 C24.677357,106.220071 25.3720972,104.252957 26.2639316,102.37474 C27.6167641,99.6313162 29.1651979,96.990545 30.8970317,94.473235 C32.8026396,91.5972928 35.0064533,88.5232627 37.1157139,85.1704423 C40.025039,80.607085 42.1270263,75.9630252 42.934364,71.7738338 L42.934364,71.7738338 C43.2252965,67.5993157 43.4653158,64.1071001 43.6616952,61.5979872 C43.7562483,60.4094601 43.8362547,59.4630403 43.8944412,58.7513913 C43.9026541,58.5054904 43.9269513,58.2604046 43.9671744,58.0177326 C43.9475523,57.9504557 43.9329647,57.881788 43.9235345,57.8123082 Z",
    id: "Path",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6321191,84.5615056 C37.6321191,84.5615056 42.1052064,73.7033563 36.4829358,66.57953 C36.3539633,66.4100985 36.1136403,66.3773399 35.9447106,66.5061641 C35.8780176,66.5579365 35.8295741,66.6299481 35.8065177,66.7115886 C35.3046591,68.5310622 34.3809484,74.099532 37.6321191,84.5615056 Z",
    id: "Path",
    fill: "#8CBF46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8175081,70.3725457 C37.0125014,71.0415987 37.1320546,71.7307032 37.1739004,72.4267901 C37.3339133,73.7033563 37.5084728,75.4714739 37.6466658,77.4303427 C37.7848587,79.3892115 37.8503185,81.1646656 37.8503185,82.455905 C37.8928508,83.1529234 37.8513316,83.8525725 37.7266722,84.5394958 C37.6005945,83.8548389 37.5397065,83.1595903 37.5448394,82.4632416 C37.4502863,80.9959241 37.3339133,79.3305188 37.210267,77.459689 C37.0866207,75.5888593 36.9702477,73.8941076 36.8684213,72.4561365 C36.7823471,71.7650764 36.7652904,71.067044 36.8175081,70.3725457 L36.8175081,70.3725457 Z",
    id: "Path",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.3,
    transform: "translate(34.911900, 66.029286)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.72021889,18.5322196 C2.72021889,18.5322196 7.19330611,7.67407035 1.57103551,0.55024405 C1.44206302,0.380812574 1.20174009,0.348053975 1.03281038,0.476878176 C0.966117367,0.52865052 0.917673809,0.600662095 0.894617444,0.682302622 C0.392758878,2.50177628 -0.530951816,8.07024606 2.72021889,18.5322196 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.7764587,110.782469 C23.7764587,110.782469 27.3622018,99.5868364 21.1798861,92.9545615 C21.1075798,92.8815352 21.0094573,92.8405018 20.9071369,92.8405018 C20.8048166,92.8405018 20.706694,92.8815352 20.6343877,92.9545615 C20.5741685,93.008192 20.5332481,93.0804256 20.5180147,93.1599859 C20.1688957,94.9501132 19.6961304,100.599285 23.7764587,110.782469 Z",
    id: "Path",
    fill: "#8CBF46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8199377,96.6448649 C22.0740838,97.2962988 22.2498975,97.9761144 22.3436162,98.669763 C22.6054554,99.9243194 22.9182078,101.677764 23.2164137,103.614623 C23.5146195,105.551482 23.7182722,107.282917 23.8273719,108.603502 C23.9231404,109.296441 23.9353515,109.998529 23.8637385,110.69443 C23.6898361,110.020904 23.5730422,109.333679 23.5146195,108.640185 C23.3036934,107.209551 23.0564008,105.536809 22.7872882,103.680652 C22.5181757,101.824496 22.2563364,100.151754 22.059957,98.7211191 C21.914822,98.0382839 21.8344531,97.3430638 21.8199377,96.6448649 L21.8199377,96.6448649 Z",
    id: "Path",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.3,
    transform: "translate(19.637944, 92.441000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.13851484,18.3414683 C4.13851484,18.3414683 7.72425793,7.14583606 1.54194226,0.513561113 C1.46963594,0.44053482 1.37151339,0.399501422 1.26919304,0.399501422 C1.16687269,0.399501422 1.06875014,0.44053482 0.996443819,0.513561113 C0.93622463,0.567191622 0.89530425,0.639425269 0.880070819,0.718985558 C0.530951816,2.50911287 0.0581865004,8.15828511 4.13851484,18.3414683 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M43.3343962,71.2896191 C43.3343962,71.2896191 52.8842556,64.5399587 51.9241783,55.48661 C51.9012786,55.2743284 51.7129536,55.1203926 51.5023262,55.1417904 C51.4215698,55.1500742 51.3453416,55.1833938 51.2841268,55.237166 C49.8949241,56.4917224 46.1709881,60.695587 43.3343962,71.2896191 Z",
    id: "Path",
    fill: "#8CBF46"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.3,
    transform: "translate(42.912544, 55.024405)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.501858566,16.3092336 C0.501858566,16.3092336 9.95716488,9.46419766 8.93162781,0.418185478 C8.91940848,0.271285638 8.82437856,0.144632643 8.68753908,0.0928714211 C8.5506996,0.0411101993 8.39654127,0.0735046637 8.29157631,0.176078096 C6.91692024,1.46731747 3.23662409,5.68585518 0.501858566,16.3092336 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M50.1858566,58.8687767 C49.9960924,59.5405841 49.7300673,60.1880451 49.3930655,60.7982992 C48.8475671,61.95748 48.054776,63.5421829 47.1310653,65.2736175 C46.2073546,67.0050521 45.3200105,68.5383988 44.6363191,69.6242138 C44.3006228,70.2341918 43.8927584,70.8008081 43.4216759,71.3116288 C43.6782692,70.6666214 43.9948603,70.0475829 44.3672066,69.4628088 C45.0508979,68.1935792 45.8582356,66.7115886 46.7455798,65.0608564 L49.1166797,60.658904 C49.4134142,60.0279482 49.7715658,59.4282936 50.1858566,58.8687767 Z",
    id: "Path",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6385877,99.6455291 C27.6385877,99.6455291 39.1595148,97.833392 42.2433993,89.2789312 C42.3170389,89.0783872 42.216305,88.8555002 42.0179266,88.7800433 C41.9424394,88.7543249 41.8606678,88.7543249 41.7851806,88.7800433 C40.003219,89.3082776 34.7737073,91.399205 27.6385877,99.6455291 Z",
    id: "Path",
    fill: "#8CBF46"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.3,
    transform: "translate(27.638588, 88.039048)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,11.6064812 C0,11.6064812 11.5209271,9.79434408 14.6048116,1.23988326 C14.6784512,1.03933926 14.5777173,0.816452282 14.3793389,0.74099532 C14.3038517,0.715276934 14.2220801,0.715276934 14.1465929,0.74099532 C12.3646313,1.26922961 7.13511961,3.360157 0,11.6064812 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39.210428,91.5459367 C38.7441181,92.0605499 38.2220204,92.5207443 37.6539391,92.9178785 C36.6574953,93.7249031 35.2537459,94.7960449 33.6754371,95.9405525 C32.0971283,97.0850601 30.6206458,98.0608262 29.529649,98.7357923 C28.9613133,99.1366952 28.3455968,99.4644837 27.6967742,99.7115584 C28.2136866,99.2483452 28.7711641,98.8333526 29.3623628,98.4716751 L33.4208712,95.5810597 L37.4721063,92.6464248 C38.0107392,92.2177668 38.593534,91.8488139 39.210428,91.5459367 Z",
    id: "Path",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#444545",
    points: "16.6340658 121.039018 13.2737954 143.855804 34.2209356 143.855804 31.50799 121.039018"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3516942,128.104151 C32.3516942,128.228873 28.5695717,128.324249 23.9073784,128.324249 C19.245185,128.324249 15.4557892,128.228873 15.4557892,128.104151 C18.2673527,127.884112 21.0883042,127.810648 23.9073784,127.884054 C26.7240297,127.81064 29.5425604,127.884104 32.3516942,128.104151 L32.3516942,128.104151 Z",
    id: "Path",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7299065,129.923625 C32.7299065,130.048347 28.8241376,130.143723 24.0019314,130.143723 C19.1797252,130.143723 15.2739564,130.048347 15.2739564,129.923625 C15.2739564,129.798903 19.1797252,129.703527 24.0019314,129.703527 C28.8241376,129.703527 32.7299065,129.798903 32.7299065,129.923625 Z",
    id: "Path",
    fill: "#FCFCFC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-30",
    transform: "translate(30.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.3474107,33.547419 L0.0795535714,33.547419 L0.0795535714,0 L33.3474107,0 L33.3474107,33.547419 Z M0.802767857,32.8181273 L32.6241964,32.8181273 L32.6241964,0.729291717 L0.802767857,0.729291717 L0.802767857,32.8181273 Z",
    id: "Shape",
    fill: "#E6F3DD"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#C8E4B4",
    x: 5.84357143,
    y: 15.5484994,
    width: 24.1119643,
    height: 10.7862245
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#C8E4B4",
    x: 6.55955357,
    y: 49.0667467,
    width: 8.07830357,
    height: 23.5269508
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#C8E4B4",
    x: 4.67196429,
    y: 91.212515,
    width: 16.9810714,
    height: 10.2319628
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3474107,76.4443577 L0.0795535714,76.4443577 L0.0795535714,42.8969388 L33.3474107,42.8969388 L33.3474107,76.4443577 Z M0.802767857,75.715066 L32.6241964,75.715066 L32.6241964,43.6262305 L0.802767857,43.6262305 L0.802767857,75.715066 Z",
    id: "Shape",
    fill: "#E6F3DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3474107,119.341297 L0.0795535714,119.341297 L0.0795535714,85.7938776 L33.3474107,85.7938776 L33.3474107,119.341297 Z M0.802767857,118.612005 L32.6241964,118.612005 L32.6241964,86.5231693 L0.802767857,86.5231693 L0.802767857,118.612005 Z",
    id: "Shape",
    fill: "#E6F3DD"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E6F3DD",
    x: 10.5372321,
    y: 10.5455582,
    width: 12.3525,
    height: 12.4563025
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E6F3DD",
    x: 10.5372321,
    y: 53.442497,
    width: 12.3525,
    height: 12.4563025
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E6F3DD",
    x: 10.53,
    y: 96.3394358,
    width: 12.3525,
    height: 12.4563025
  })), /*#__PURE__*/React.createElement("path", {
    d: "M113.03094,95.8698475 C109.521938,98.1311409 104.008842,98.6287718 102.650755,102.309777 C101.608332,105.163837 104.537394,106.466459 104.280459,110.484097 C103.832658,117.428975 94.135187,121.95888 93.4524733,122.266241 C87.153889,125.1203 84.5771954,122.851689 80.7965766,125.735021 C79.8871663,126.402836 79.1083649,127.231296 78.4988413,128.179267 C75.8927837,132.379857 76.0689679,134.714332 74.4392642,137.846479 C72.0387548,142.478838 65.9236957,146.035435 61.3282251,144.725495 C58.5239603,143.920504 56.9236207,141.483576 56.5272063,140.832265 C53.8110336,136.638992 56.3583631,133.477572 53.7743285,127.096188 C52.6438134,124.307991 52.4896523,124.586079 51.3224321,122.339422 C49.3618037,118.565638 49.5947073,114.031196 51.9317357,110.476779 C54.6258854,106.415232 60.0875949,102.924498 58.8616466,98.2775029 C58.3184121,96.2137982 56.4978423,94.6184521 55.6683084,92.598656 C54.200107,89.0347404 56.218884,85.0244206 59.228697,82.4191764 C62.23851,79.8139322 66.1219029,78.1893136 69.5648354,76.0451098 C71.3052449,75.0535664 72.6602165,73.5069132 73.4115232,71.6542487 C74.7035405,68.9465511 73.7125045,67.8707901 74.6227894,65.3972717 C76.0102398,61.606495 80.6057104,58.0352614 84.2688731,58.5768009 C86.3904242,58.8987974 87.5282803,60.4941436 90.4279782,60.2453281 C91.2583995,60.1655738 92.0723389,59.9633405 92.8431697,59.6452437 C95.7795726,58.4889837 95.9043697,56.718003 97.9818748,55.6641964 C100.57325,54.3323019 104.030865,55.1812017 106.130393,56.644822 C107.238885,57.4278589 107.936281,58.5768009 109.323731,60.889321 C110.839035,63.3035049 111.887299,65.9792835 112.414295,68.7782347 C112.53972,69.55114 112.620604,70.3305763 112.656549,71.1127092 L112.656549,71.1127092 C112.774005,73.1983682 111.804992,75.2401186 112.039904,77.3257776 C112.392272,80.4359708 115.29197,82.8509444 116.481213,85.8147756 C117.858814,89.5581357 116.419794,93.7518468 113.03094,95.8698475 L113.03094,95.8698475 Z",
    id: "Path",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.358224,94.9737808 C108.187868,97.2647476 103.266828,97.8154607 101.986917,101.523596 C100.986526,104.460733 103.82587,105.819159 103.36981,109.696179 C102.693075,115.445625 95.4181747,119.241874 92.3949352,120.857299 C86.6132653,123.889893 85.0391211,122.472724 82.1482862,125.204262 C77.7936443,129.30891 79.8312048,132.172619 76.3298373,137.408065 C73.6891001,141.351171 66.9658861,144.648108 62.3537907,142.107484 C57.0355372,139.170347 57.9403023,130.461737 58.2713139,128.721483 C58.3996856,128.047535 58.6096398,127.391661 58.8965581,126.768287 C59.9337279,124.815091 61.8388837,124.403892 62.6700907,120.894013 C63.7293279,116.561737 61.2945535,115.636538 62.0154233,111.700775 C63.1114395,105.74573 68.473828,105.466702 70.9453815,98.9536013 C71.9678396,96.2514354 71.3278838,93.2408701 71.519135,90.362476 C71.7913001,86.3826556 74.0716024,82.2853497 77.8598467,81.0076952 C81.2582327,79.8695547 85.8261932,80.7800671 87.7828398,77.7841875 C89.0186165,75.8970771 88.0844281,74.7589366 89.2025119,71.5721431 C89.6585723,70.2651172 91.6152189,65.4996127 96.4627003,63.7153021 C100.236233,62.3275049 105.289677,62.9222752 107.886279,65.8226978 C110.166582,68.3780068 108.401186,70.3312028 110.64471,76.4184189 C112.476307,81.3968658 113.40314,81.6098083 114.558003,84.8920587 C115.753847,88.5899295 114.469064,92.6379668 111.358224,94.9737808 L111.358224,94.9737808 Z",
    id: "Path",
    fill: "#181F21"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#322C74",
    points: "66.2452107 314 64 313.438356 65.7701149 307 68 307.561644"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7177405,318.877505 C85.4754327,319.483393 84.9011657,319.907017 84.2313272,319.974001 C83.6344919,320.018086 83.0346247,320.006085 82.4401991,319.938168 C76.9999263,319.321837 75.0081324,314.427023 69.3300335,311.402701 C68.4485921,310.929521 67.5259899,310.531456 66.5727367,310.213039 C64.3431167,309.460542 63.3472198,306.708553 64.4545977,304.479728 L65.1978044,303.046401 C65.4870374,302.405707 66.1454015,301.993759 66.8700194,302 C68.5972685,302.020164 70.2887515,302.477359 71.7751834,303.3259 C76.9776301,306.350221 76.9776301,313.022361 82.1206203,315.408852 C82.8405962,315.74551 83.6102438,315.972751 84.4022647,316.082516 C85.0274027,316.219175 85.5503507,316.629773 85.8158186,317.192381 C86.0812864,317.75499 86.0587497,318.404919 85.7549009,318.949171 L85.7177405,318.877505 Z",
    id: "Path",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4581672,305.029964 C68.0475621,303.750951 66,303.392827 66,302.501172 C66,301.996876 66.6316947,301.624135 66.769651,301.536431 C70.7631233,298.985714 75.4318554,273.032711 75.4318554,273.032711 C76.6617075,266.047046 78.6510387,259.218707 81.3639769,252.670822 C88.1310972,236.686813 96.8876927,232.835156 98.6230379,232.411255 C100.538503,231.65716 102.7051,231.952916 104.351855,233.19328 C105.898015,234.359489 106.860332,236.147861 106.98598,238.088538 C107.111627,240.029215 106.388043,241.92818 105.005333,243.28652 C103.553161,244.74825 101.868642,246.509633 100.067949,248.651067 C94.048697,255.798923 90.7159629,262.164754 86.6644037,270.01424 C83.7911699,275.316653 81.2544723,280.796928 79.0695456,286.422151 C76.7678534,292.502944 73.9869445,301.32448 73.9869445,301.32448 C74.7951488,303.243208 75.476729,305.213512 76.0272458,307.222558 C76.2958976,308.201916 76.4628973,308.801225 76.223289,308.962016 C75.6133769,309.334757 73.9869445,306.88636 70.4581672,305.029964 Z",
    id: "Path",
    fill: "#FFC586"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#263238",
    points: "124 318.545908 121.776119 319 120 312.447106 122.201493 312"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.987176,313.825566 C144.067595,314.506534 143.7654,315.175939 143.20393,315.560571 C142.695669,315.88429 142.158765,316.159553 141.60014,316.382812 C136.475472,318.404469 132.305619,314.821308 125.808405,314.715699 C124.794714,314.696061 123.781282,314.76674 122.779854,314.926917 C120.445034,315.289005 118.207188,313.207 118.087836,310.581863 L118.005782,308.892119 C117.948068,308.159986 118.326282,307.463232 118.968056,307.119397 C120.508876,306.312536 122.232589,305.930089 123.965912,306.010503 C130.075232,306.32733 133.30519,312.543172 139.041536,312.294236 C139.844141,312.263495 140.637016,312.10568 141.391275,311.82654 C142.007826,311.661169 142.665344,311.793036 143.172826,312.183832 C143.680308,312.574629 143.980861,313.180545 143.987176,313.825566 L143.987176,313.825566 Z",
    id: "Path",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.095038,309.097403 C120.374805,309.097403 118.392508,309.774573 117.965663,308.957553 C117.734154,308.501199 118.110356,307.875553 118.189937,307.728342 C120.512264,303.554916 112.532431,278.28618 112.532431,278.28618 C110.348234,271.484833 108.904709,264.460035 108.227807,257.338081 C106.780874,239.908321 112.648186,232.312243 113.972129,231.097754 C115.211109,229.889082 116.819689,229.14873 118.529966,229 C118.81079,229.004278 119.091076,229.026403 119.369187,229.066245 C121.271198,229.366049 122.949719,230.495872 123.964805,232.159586 C124.979891,233.8233 125.230333,235.855025 124.650491,237.722241 C124.042779,239.687505 123.39166,242.087041 122.805652,244.847244 C120.845058,254.070001 120.881232,261.312773 120.975282,270.226388 C120.928435,276.311773 121.261902,282.394032 121.973666,288.436365 C122.783948,294.935723 124.44792,304.106956 124.44792,304.106956 C126.05145,305.425989 127.569099,306.849568 128.991288,308.368709 C129.714755,309.104763 130.105427,309.568477 129.975203,309.840817 C129.627939,310.459103 127.088572,309.075321 123.095038,309.097403 Z",
    id: "Path",
    fill: "#FFB878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.608172,145.581049 C105.257203,141.181534 97.3368256,145.786359 93.4353064,152.458957 C90.5018334,157.540396 90.9565217,163.831702 91.1398638,169.712387 C91.9970404,199.076071 83.1623773,227.905301 66,251.748671 C88.6757465,260.928992 115.869041,257.907992 136,243.976195 C127.935604,226.238514 123.449775,207.084558 122.799371,187.611079 C122.286014,172.014799 123.53274,154.431406 112.942902,143 L111.608172,145.581049 Z",
    id: "Path",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.903885,113.298733 C149.184348,115.921526 148.903885,118.331858 147.353953,119.82641 C144.158142,122.96204 138.445538,119.26229 122.104833,115.210881 C111.188888,112.500173 108.303064,110.199735 102.915207,107.818708 C99.6813401,106.389 98.1603612,102.680848 99.4684548,99.4155133 L99.5201192,99.2763148 C100.052507,97.7857533 101.077428,96.5179163 102.428086,95.6791323 C107.919271,92.5947864 116.237236,100.653647 130.171857,107.0348 C136.174428,109.776226 142.453769,111.876019 148.903885,113.298733 L148.903885,113.298733 Z",
    id: "Path",
    fill: "#FFBF8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.299712,69.1947508 C130.783985,69.9123739 131.029182,70.7778949 130.99723,71.6569256 C130.979203,72.5404521 130.85021,73.4176103 130.613595,74.2656586 C130.125333,77.2627703 131.248336,78.7136947 130.18811,80.0547007 C129.912353,80.4074348 129.570454,80.6967809 129.183684,80.9047373 L126.393614,80.4650632 C126.25411,80.9047373 126.135532,81 126.05183,81 C125.45894,81 124.356862,76.4273895 125.493816,72.0965997 C125.821649,70.8362007 126.505217,68.2274678 128.011855,68.0003028 C128.913382,67.9867067 129.765595,68.4316312 130.299712,69.1947508 Z",
    id: "Path",
    fill: "#FFBF8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.202899,120.726237 C144.162984,121.619391 141.780602,120.054526 141.542364,119.899515 C138.862184,118.091062 138.564386,114.880135 137.633768,110.643187 C136.698957,106.258941 135.337609,101.974886 133.568829,97.8511486 C132.660546,95.8212521 129.206092,88.5652947 126.257894,83.708306 C125.375903,82.4017536 124.937708,80.8501209 125.007144,79.2794409 C125.120932,78.1704903 125.512491,77.1073276 126.14622,76.1866168 L126.19089,76.1866168 C127.312908,75.7090335 128.616147,76.177428 129.168867,77.2569258 C130.345169,79.6189872 131.930942,82.6010897 133.941076,85.9448829 C137.48487,91.8500363 139.897031,94.750943 141.825272,97.7109012 C145.29798,103.1209 147.712478,109.1307 148.942638,115.426362 C149.232991,116.526196 148.436382,119.759268 146.202899,120.726237 Z",
    id: "Path",
    fill: "#FFBF8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6374939,139.816137 C90.2391341,132.5791 88.1052736,125.497943 85.2679259,118.678903 C83.3748725,114.087021 80.2865972,107.461591 83.189279,101.914889 C83.3377538,101.630629 83.4565336,101.426546 83.5827372,101.186019 C87.0496232,95.7559359 93.8868867,93.5255932 95.9803811,92.8404553 C97.8250073,92.1899883 99.7845194,91.9123165 101.741202,92.0241207 C103.22595,92.1334512 105.133851,92.2792253 106.752226,93.4235514 C108.867992,94.8812917 108.927382,97.0168813 110.872401,103.992169 C111.473185,106.175412 112.204453,108.322009 113.062404,110.420804 C113.062404,110.522845 113.099523,110.675908 113.121794,110.858126 C113.975524,117.731371 111.251012,122.979237 110.449248,125.187713 C109.172365,128.679001 109.150094,134.342322 115,143.722881 C113.98324,144.621131 112.912281,145.458419 111.792945,146.230195 C108.548771,148.416805 107.190227,148.358496 104.265274,150.056763 C101.0211,151.944537 101.214117,152.870202 97.4057389,155.516001 C95.4460395,156.867461 93.3605879,158.033985 91.177222,159 C92.53483,152.688026 92.6908819,146.183872 91.6374939,139.816137 Z",
    id: "Path",
    fill: "#6A9D44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.68,130.77 C119.41,130.35 119.32,130.23 119.32,130.23 L119.68,130.77 Z",
    id: "Path",
    fill: "#FF9419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.718729,89.1161064 C102.997014,90.9411068 103.425596,92.7393851 104,94.4921635 C102.939923,95.6839914 101.54133,96.5148823 99.9960291,96.8708846 C96.1376572,97.658882 93.6406353,94.6173593 93,93.7630818 C94.2722969,91.9511819 95.2549636,89.9481211 95.9119788,87.8273256 C96.5244183,85.865836 96.8458079,83.8232839 96.8656519,81.7663736 C96.886993,79.8227422 96.659422,77.8844986 96.1886168,76 L103.228326,76.4934189 C102.403006,80.0400923 102.15709,83.6995067 102.500331,87.3265422 C102.553717,87.9156991 102.626517,88.5122205 102.718729,89.1161064 Z",
    id: "Path",
    fill: "#FFB876"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,77.4791938 C103.175927,80.9236172 102.930383,84.4775313 103.273105,88 C100.877676,86.8226215 98.9195065,84.9334509 97.6760125,82.60013 C97.6973213,80.7125333 97.4700941,78.8301688 97,77 L104,77.4791938 Z",
    id: "Path",
    fill: "#F8A867"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.596985,68.3079376 C106.018997,69.2345023 106.722439,70.6498846 108.121759,73.4733534 C109.30929,75.8590751 109.906838,77.048288 109.990041,78.7044312 C110.080807,80.6232227 109.58159,84.17627 107.22922,85.4822155 C103.976746,87.2842744 98.3870295,84.1106079 95.9287644,80.1562924 C93.7201077,76.5959493 92.8502601,70.4674899 96.3825979,68.0306977 C98.7198407,66.4183292 102.380765,66.8414848 104.596985,68.3079376 Z",
    id: "Path",
    fill: "#FFC586"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.809813,117.806335 C135.225081,120.505131 135.028375,123.007519 133.534867,124.622433 C130.409427,128.01957 124.362539,124.476945 107.380255,121.079808 C96.0368755,118.8102 92.9624336,116.576964 87.3235284,114.372825 C83.9257176,113.049098 82.1822352,109.281551 83.3748376,105.839972 L83.4258355,105.694484 C83.8963717,104.127187 84.888417,102.767113 86.2380027,101.839061 C91.7239144,98.3910024 100.655824,106.305533 115.277636,112.226882 C121.572678,114.770439 128.119967,116.640702 134.809813,117.806335 Z",
    id: "Path",
    fill: "#FFC586"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#263238",
    points: "147 74.8061041 119.711181 75 119 69.6355476 145.431003 63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.847431,73.6847943 C148.399885,74.3764789 147.656104,74.8492906 146.810262,74.9797957 C144.657781,75.2489813 142.543737,72.7972092 142.090178,69.486953 C141.886552,68.1433668 142.028967,66.7731105 142.505299,65.4928198 C143.035732,64.1177903 143.988974,63.1720028 145.172838,63.0192217 C147.32532,62.7573114 149.439363,65.2018082 149.892922,68.526615 C150.203657,70.3089619 149.832984,72.1377697 148.847431,73.6847943 Z",
    id: "Path",
    fill: "#BDD0D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.519299,73.6632094 C148.0932,74.3662458 147.385061,74.8468172 146.579752,74.9794641 C144.530418,75.2530676 142.51768,72.7610574 142.085857,69.3964739 C141.891989,68.030837 142.027579,66.6380922 142.481085,65.3367896 C142.908618,64.6351437 143.616055,64.1550485 144.420633,64.020535 C146.469966,63.7469315 148.482704,66.2389417 148.914528,69.6109199 C149.10778,70.9741284 148.972191,72.36433 148.519299,73.6632094 L148.519299,73.6632094 Z",
    id: "Path",
    fill: "#DFF0F7"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#263238",
    points: "138 75.8061041 110.711181 76 110 70.6355476 136.431003 64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.459758,73.63086 C139.911984,74.940412 138.970739,75.8134466 137.821185,75.9807783 C135.66095,76.2426887 133.539291,73.7981916 133.084098,70.4733846 C132.944831,69.4878755 132.978717,68.4874614 133.184395,67.5123421 C133.593296,65.5916658 134.72742,64.1948104 136.170148,64.0202034 C138.338099,63.7510177 140.452043,66.2027901 140.907235,69.5203218 C141.119655,70.9043368 140.965935,72.3164069 140.459758,73.63086 L140.459758,73.63086 Z",
    id: "Path",
    fill: "#BDD0D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.835332,73.5998278 C140.33341,74.926533 139.470953,75.8110031 138.417624,75.9805265 C136.438213,76.2458675 134.494149,73.7693513 134.077059,70.4009944 C133.949449,69.4025766 133.980499,68.3890586 134.16896,67.4011667 C134.663813,66.0744616 135.52627,65.1899915 136.579599,65.0204681 C138.566079,64.7477564 140.503074,67.2316433 140.920164,70.5926296 C141.049983,71.5931113 141.021324,72.6090305 140.835332,73.5998278 L140.835332,73.5998278 Z",
    id: "Path",
    fill: "#DFF0F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.433499,70.0310916 C125.481921,70.3345173 125.869694,71.6999331 125.912779,71.9455635 C126.121028,72.7185767 125.984589,73.2242862 125.194682,75.8756492 C124.749462,77.378329 124.095994,78.815989 123.708221,80.3403421 C123.588338,81.0645316 123.244008,81.7320732 122.724428,82.2475896 C122.372594,82.5568178 121.951097,82.775041 121.496482,82.8833387 C120.426517,83.1650912 118.954418,82.9411341 118.286588,82.1608965 C117.834186,81.6118404 117.647481,80.8749493 119.844858,75.1965535 C120.972271,72.3067846 121.41031,71.2953655 122.508999,70.5584744 C123.044868,70.1116606 123.746418,69.9194105 124.433499,70.0310916 L124.433499,70.0310916 Z",
    id: "Path",
    fill: "#FFC586"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.111205,126.92519 C128.906645,127.412278 126.790268,125.36942 126.584509,125.158591 C124.247675,122.803126 124.600405,119.509836 124.526919,115.067893 C124.48942,110.470692 123.997171,105.888159 123.057213,101.385836 C122.550164,99.16123 120.558711,91.2078985 118.574607,85.6972722 C117.953187,84.1962826 117.83219,82.5382635 118.229226,80.9645311 C118.561447,79.8609475 119.173656,78.8598527 120.007571,78.0565488 L120.051662,78.0565488 C121.290756,77.7836444 122.527566,78.5235607 122.858802,79.7359086 C123.593656,82.3458226 124.548965,85.6681924 125.893747,89.4340294 C128.267323,96.0787688 130.089759,99.4738381 131.434541,102.839828 C133.838157,108.979784 135.047383,115.513777 134.99858,122.09794 C134.99858,123.304753 133.528873,126.394484 131.111205,126.92519 Z",
    id: "Path",
    fill: "#FFC586"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Board--inject-30",
    transform: "translate(178.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E2EDDB",
    x: 3.7771607,
    y: 5.3092437,
    width: 146.299096,
    height: 96.3321429
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#455A64",
    x: 0.292803155,
    y: 0.590726291,
    width: 153.341012,
    height: 4.71851741
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FCFCFC",
    x: 112.33393,
    y: 25.3210084,
    width: 19.4421295,
    height: 22.9508103
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.757723,26.8816927 C122.757723,27.2844694 122.429992,27.6109844 122.025715,27.6109844 C121.621438,27.6109844 121.293707,27.2844694 121.293707,26.8816927 C121.293707,26.478916 121.621438,26.152401 122.025715,26.152401 C122.429992,26.152401 122.757723,26.478916 122.757723,26.8816927 Z",
    id: "Path",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FCFCFC",
    x: 118.687759,
    y: 56.8409964,
    width: 23.0070079,
    height: 27.1588235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.89033,60.5312125 C130.900284,60.7246946 130.832556,60.9141713 130.702092,61.0578336 C130.571628,61.2014958 130.38915,61.2875359 130.194923,61.2969688 C129.994522,61.3069643 129.798788,61.2345641 129.653489,61.0966971 C129.508189,60.95883 129.426064,60.7675841 129.426314,60.5676771 C129.425826,60.1787214 129.731806,59.8578329 130.121722,59.8383854 L130.194923,59.8383854 C130.571108,59.8567 130.871947,60.1564228 130.89033,60.5312125 L130.89033,60.5312125 Z",
    id: "Path",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#8CBF46",
    x: 129.989961,
    y: 19.0053421,
    width: 11.697486,
    height: 11.6540816
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.534112,20.1940876 C136.534112,20.5968643 136.20638,20.9233794 135.802103,20.9233794 C135.397826,20.9233794 135.070095,20.5968643 135.070095,20.1940876 C135.070095,19.7913109 135.397826,19.4647959 135.802103,19.4647959 L135.838704,19.4647959 C136.22862,19.4842434 136.534599,19.8051319 136.534112,20.1940876 L136.534112,20.1940876 Z",
    id: "Path",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#C2E2AA",
    x: 3.7771607,
    y: 5.3092437,
    width: 146.299096,
    height: 6.12605042
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#E6F3DD",
    points: "189 299 189 319 218.964223 319 252 319 252 299"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#C8E4B4",
    points: "186 293 186 299 254 299 254 293 218.682228 293"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#C8E4B4",
    points: "220.309574 319 251.8125 319 251.8125 298.676314 254 298.676314 254 293 219 293 219 298.157629"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#C8E4B4",
    x: 198,
    y: 302,
    width: 13,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 196,
    y: 309,
    width: 16,
    height: 6
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#E6F3DD",
    points: "195 273 195 293 224.964223 293 258 293 258 273"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#C8E4B4",
    points: "192 267 192 273 260 273 260 267 224.678393 267"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#C8E4B4",
    points: "226.309574 293 257.8125 293 257.8125 272.683619 260 272.683619 260 267 225 267 225 272.157629"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#C8E4B4",
    x: 203,
    y: 276,
    width: 13,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 202,
    y: 283,
    width: 16,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E6F3DD",
    x: 164,
    y: 135,
    width: 67,
    height: 60
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.750629,195 L230.750629,178.591687 C230.750629,168.168704 230.699288,153.278729 230.677285,135.352078 L230.816639,135.506112 L164.161357,135.506112 L164.344718,135.322738 L164.344718,194.977995 L164.190695,194.823961 L212.414559,194.897311 L212.473235,194.897311 L164.154023,194.977995 L164,194.977995 L164,135 L231,135 L231,135.146699 C231,153.110024 230.941325,168.02934 230.926656,178.474328 C230.926656,183.682152 230.926656,187.760391 230.882649,190.518337 L230.882649,193.687042 C230.881592,194.127954 230.837374,194.567704 230.750629,195 Z",
    id: "Path",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190,145.5 C190,145.64 186.421151,145.74 182.003744,145.74 C177.586336,145.74 174,145.64 174,145.5 C174,145.36 177.578849,145.26 182.003744,145.26 C186.428638,145.26 190,145.37 190,145.5 Z",
    id: "Path",
    fill: "#85C555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218,150.505 C218,150.635 208.352329,150.745 196.488995,150.745 C184.625661,150.745 175,150.595 175,150.505 C175,150.415 184.632998,150.255 196.511005,150.255 C208.389012,150.255 218,150.325 218,150.505 Z",
    id: "Path",
    fill: "#85C555"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B6DC99",
    x: 174,
    y: 158,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B6DC99",
    x: 181,
    y: 158,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B6DC99",
    x: 188,
    y: 157,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B6DC99",
    x: 195,
    y: 158,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B6DC99",
    x: 202,
    y: 158,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B6DC99",
    x: 209,
    y: 158,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B6DC99",
    x: 216,
    y: 158,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B6DC99",
    x: 174,
    y: 164,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B6DC99",
    x: 181,
    y: 164,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B6DC99",
    x: 188,
    y: 164,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B6DC99",
    x: 195,
    y: 164,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B6DC99",
    x: 202,
    y: 164,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B6DC99",
    x: 209,
    y: 163,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B6DC99",
    x: 216,
    y: 164,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B6DC99",
    x: 174,
    y: 169,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B6DC99",
    x: 181,
    y: 169,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B6DC99",
    x: 188,
    y: 169,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B6DC99",
    x: 195,
    y: 169,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B6DC99",
    x: 202,
    y: 169,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B6DC99",
    x: 209,
    y: 169,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B6DC99",
    x: 216,
    y: 169,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B6DC99",
    x: 174,
    y: 175,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B6DC99",
    x: 181,
    y: 175,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B6DC99",
    x: 188,
    y: 175,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B6DC99",
    x: 195,
    y: 175,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B6DC99",
    x: 202,
    y: 175,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B6DC99",
    x: 209,
    y: 175,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B6DC99",
    x: 216,
    y: 175,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B6DC99",
    x: 174,
    y: 181,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B6DC99",
    x: 181,
    y: 181,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B6DC99",
    x: 188,
    y: 181,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B6DC99",
    x: 195,
    y: 181,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B6DC99",
    x: 202,
    y: 181,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B6DC99",
    x: 209,
    y: 181,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B6DC99",
    x: 216,
    y: 181,
    width: 3,
    height: 3
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmtpyPage);
export default __webpack_public_path__ + "static/media/EmtpyPage.1e986a083929e6ed44df79bebeccdb2a.svg";
export { ForwardRef as ReactComponent };